define('models/shared/lookups/lookups',["backbone",
        "models/shared/lookups/lookup"
], function (Backbone, Lookup) {
    var Lookups = Backbone.Collection.extend({
        url: function () {
            var url = pf.lookupsURL;
            return url;
        },
        model: Lookup,
        initialize: function (attributes, options) {
            options || (options = {});
        }
    });
    return Lookups;
});

